import React, {Component} from 'react';
import Person from '../forecast-app/shared/components/person/person';
import {profilePicSrc} from '../constants';
import {Scrollbars} from 'react-custom-scrollbars';
import CheckBox from '../components/new-ui/check_box';
import {injectIntl} from 'react-intl';
import Util from '../forecast-app/shared/util/util';
import UpdatePersonMutation from '../mutations/update_person_mutation.modern';
import updatePersonInternalDataMutation from '../mutations/mission_control/update_person_internal_data_mutation';
import {personIsClientUser, personIsVirtualUser} from '../forecast-app/shared/util/PermissionsUtil';

class UserSelectSideMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			shouldAnimate: false,
			hideMenu: !props.shown,
			animation: '',
		};
		this.animateToClose = this.animateToClose.bind(this);
		this.animateToOpen = this.animateToOpen.bind(this);
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevProps.shown && this.props.shown && this.state.hideMenu) {
			this.animateToOpen();
		}
		if (prevProps.shown && !this.props.shown) {
			this.animateToClose();
		}
	}

	animateToOpen() {
		this.setState({hideMenu: false, animation: 'slideIn'}, () => this.focusContainer());
	}

	animateToClose() {
		this.setState({animation: 'slideOut'});
	}

	focusContainer() {
		if (this.container) {
			this.container.focus();
		}
		if (this.scrollWrapper) {
			const scrollTop = this.scrollWrapper.getBoundingClientRect().top;
			this.setState({scrollHeight: window.innerHeight - scrollTop});
		}
	}

	onAnimationEnd() {
		if (this.state.animation === 'slideOut') {
			this.setState({hideMenu: true});
		}
	}

	handlePersonCheck(user) {
		if (user.id === this.props.viewerPersonId) {
			return;
		}
		const isActive = user.active;
		if (this.props.isFromMissionControl) {
			this.props.handleUserActivatedChange(user.id);
			Util.CommitMutation(updatePersonInternalDataMutation, {id: user.id, active: !isActive});
		} else {
			Util.CommitMutation(UpdatePersonMutation, {id: user.id, active: !isActive});
		}
	}
	handleBlur(e) {
		const newTarget = e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
		if (newTarget && this.container && this.container.contains(newTarget)) return;
		if (!this.state.hideMenu) {
			this.animateToClose();
			if (newTarget.id !== 'edit-users-btn' && this.props.onBlur) {
				this.props.onBlur();
			}
		}
	}

	render() {
		const {formatMessage} = this.props.intl;
		const virtualUsers = [];
		const users = [];
		this.props.users.forEach(user => {
			if (!personIsClientUser(user)) {
				if (personIsVirtualUser(user)) {
					virtualUsers.push(user);
				} else {
					users.push(user);
				}
			}
		});

		const activeUserCount = users.filter(user => user.active).length;
		const activeVirtualUserCount = virtualUsers.filter(user => user.active).length;

		const isDisabled = user => user.id === this.props.viewerPersonId;
		const getUserList = users =>
			users.map(user => (
				<div className={'person-row-item' + (user.active ? ' highlighted' : '') + (isDisabled(user) ? ' disabled' : '')} onClick={this.handlePersonCheck.bind(this, user)}>
					<Person
						key={user.id}
						name={user.firstName + (user.lastName ? ' ' + user.lastName : '')}
						role={user.role ? user.role.name : ''}
						showName={true}
						showRole={true}
						imageSize="new-ui-person-dropdown"
						imageSrc={user.profilePictureId ? profilePicSrc(user.profilePictureId) : null}
					/>
					{isDisabled(user) ? null : (
						<CheckBox
							title={user.active ? formatMessage({id: 'common.deactivate'}) : formatMessage({id: 'common.activate'})}
							isDisabled={isDisabled(user)}
							isChecked={user.active}
							onChange={this.handlePersonCheck.bind(this, user)}
						></CheckBox>
					)}
				</div>
			));
		return this.state.hideMenu ? null : (
			<div ref={div => (this.container = div)} onBlur={this.handleBlur.bind(this)} tabIndex="0" className={'user-select-modal-wrapper ' + this.state.animation} onAnimationEnd={this.onAnimationEnd.bind(this)}>
				<h1 className={'modal-header'}>{formatMessage({id: 'common.select_users'})}</h1>
				<div className={'modal-description'}>
					<div className={'desc-1'}>{formatMessage({id: 'licensing.user_select_description_1'})}</div>
					<div className={'desc-2'}>{formatMessage({id: 'licensing.user_select_description_2'})}</div>
				</div>
				<div className={'scroll-wrapper'} ref={div => (this.scrollWrapper = div)}>
					<Scrollbars autoHeightMin={this.state.scrollHeight} hideTracksWhenNotNeeded={true} autoHide autoHeight={true}>
						<div className={'user-list-wrapper'}>
							<div className={'list-header'}>{formatMessage({id: 'settings_subscription.users'}) + ' (' + activeUserCount + '/' + users.length + ')'}</div>
							{getUserList(users)}
						</div>
						<div className={'user-list-wrapper virtual'}>
							<div className={'list-header'}>{formatMessage({id: 'settings_subscription.virtual_users'}) + ' (' + activeVirtualUserCount + '/' + virtualUsers.length + ')'}</div>
							{getUserList(virtualUsers)}
						</div>
					</Scrollbars>
				</div>
			</div>
		);
	}
}
UserSelectSideMenu.propTypes = {};
export default injectIntl(UserSelectSideMenu);
